import React from 'react';
import css from './OrderPanel.module.css';
import { Card } from '../Card/Card';
import { AvatarMedium } from '../Avatar/Avatar';
import { LocationTag } from '../Tag/TagComponent';
import { BackgroundCheckIcon } from '../BackgroundCheckIcon/BackgroundCheckIcon';
import { PrimaryButton } from '../Button/Button';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import Icon from '../Icon/Icon';
import { OrganizationBadge } from '../OrganizationBadge/OrganizationBadge';

export const GetInTouchPanel = ({ author, listing, publicData }) => {
  const location = useHistory();
  const isOrganization =
    publicData?.i_am_agency === 'yes' && publicData?.organization_name?.length > 0;
  const isBackgroundCheck = publicData?.background_check === 'yes';

  return (
    <Card>
      <div className={css.wrapper}>
        <div className={css.header}>
          <Icon icon={'Phone'} />
          {'Contact me'}
        </div>
        <div className={css.contactAuthorSection}>
          <AvatarMedium user={author} />
          <div
            className={css.column}
            style={{
              gap: 6,
            }}
          >
            <div
              className={css.row}
              style={{
                gap: 6,
              }}
            >
              <div className={css.name}>{author?.attributes?.profile?.displayName}</div>
              {isOrganization && <OrganizationBadge />}
              {isBackgroundCheck && <BackgroundCheckIcon />}
            </div>
            <div>
              <LocationTag text={publicData?.location?.address} />
            </div>
          </div>
        </div>
        <div>
          <div className={css.createAccountCard}>
            <div className={css.createAccountHeader}>Create an account</div>
            <div className={css.createAccountDescription}>To contact me</div>
          </div>
          <div className={css.haveAccountWrapper}>
            Already have an account?
            <div
              className={css.haveAccountWrapperLink}
              onClick={() => {
                location.push('/login');
              }}
            >
              Log in
            </div>
          </div>
        </div>
        <PrimaryButton
          onClick={() => {
            location.push('/signup');
          }}
        >
          <FormattedMessage id="Cappa.ctaButtonNow" />
        </PrimaryButton>
      </div>
    </Card>
  );
};
